import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * Korenova cesta jen presmerovava: prihlaseny na prehled, ostatni na
 * prihlaseni. Vlastni rozcestnik by tu nic nepridal.
 */
export const Route = createFileRoute('/')({
  beforeLoad: ({ context }) => {
    throw redirect({ to: context.auth.isAuthenticated ? '/dashboard' : '/login' })
  },
})
